import { useIsMobile } from 'src/hooks';
import { Box } from 'src/components';
import AnimationControlsHeader from './animation-controls-header';
import AnimationControlsFooter from './animation-controls-footer';

export default function AnimationControlsContainer({ mapRef, routeRef, startAnimation, stopAnimation, toggleVisualisationView, inVisualisationView }) {
  const isMobile = useIsMobile();

  if (!inVisualisationView ) return;

  return (
     <Box sx={{
        position: 'absolute',
        top: isMobile ? 0 : '75px',
        bottom: isMobile ? 0 : 0,
        left: isMobile ? 0 : 0,
        right: isMobile ? 0 : 0,
        m: isMobile ? 0 : 3,
        mb: isMobile ? 0 : 5,
        borderRadius: isMobile ? 0 : 8,
        width: isMobile ? '100%' : '300px',
        boxShadow: isMobile ? 'none' : '0 4px 20px rgba(0,0,0,0.05)',
        overflow: 'hidden',
        background: isMobile ? 'transparent' : 'white',
        pointerEvents: inVisualisationView ? 'auto' : 'none'
     }}>

        {/* Header - Absolute positioned */}
        <AnimationControlsHeader 
            toggleVisualisationView={toggleVisualisationView}
        />

        {/* Footer - Positioned differently depending on device */}
        <AnimationControlsFooter 
            mapRef={mapRef}
            routeRef={routeRef}
            startAnimation={startAnimation}
            stopAnimation={stopAnimation}
        />
        
    </Box>
  );
}
